import script from "./AppTopbar.vue?vue&type=script&setup=true&lang=js"
export * from "./AppTopbar.vue?vue&type=script&setup=true&lang=js"

import "./AppTopbar.vue?vue&type=style&index=0&id=3d747e8a&lang=scss&scoped=true"

import exportComponent from "C:\\Source\\Tms\\TmsUI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d747e8a"]])

export default __exports__